import { Box, Typography } from "@mui/material";
import { Question } from "../../utils/CourseTree";
import { makeStyles } from "@mui/styles";

interface CheckWorkSkillProps {
  currentQuestion: Question;
}

const useStyles = makeStyles((theme) => ({
  mockPageContainer: {
    border: "none",
    flexGrow: 1,
    overflowY: "auto",
  },
  mockContainer: {
    display: "flex",
    width: "100%",
    height: "99%",
  },
  content: {
    width: "100%",
    padding: "50px 55px",
  },
  problemTitle: {
    font: "normal normal 600 36px/43px proxima-soft",
    borderBottom: "1px solid rgb(230, 230, 230)",
    paddingBottom: 10,
    marginBottom: 0,
    marginTop: 0,
    display: "inline-block",
  },
  videoContent: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    marginTop: "12px",
  },
  iframeStyle: {
    flexGrow: 1,
  },
  videoHeader: {
    fontWeight: 600,
    fontSize: "1.1250em",
  },
}));

export const CheckWorkSkills = ({ currentQuestion }: CheckWorkSkillProps) => {
  const classes = useStyles();

  return (
    <Box className={classes.mockPageContainer}>
      <Box className={classes.mockContainer}>
        <Box className={classes.content}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <h1 className={classes.problemTitle} id="mock-problem-title">
              Problem video: {currentQuestion.question_skills.length}{" "}
              {currentQuestion.name.split(":")[0]}
            </h1>
          </Box>
          <Box
            sx={{
              width: "100%",
              height: "100%",
              marginBottom: "100px",
              overflowY: "auto",
            }}>
            {currentQuestion.question_skills.map((skill, index) => {
              return (
                <Box style={{ paddingTop: "48px" }}>
                  <Typography
                    style={{ font: "normal normal 600 18px/24px" }}
                    className={classes.videoHeader}
                    variant={"body1"}>
                    Part {(index + 10).toString(36).toUpperCase()}
                  </Typography>
                  <Box className={classes.videoContent} id="iframe-content-wrapper">
                    <iframe
                      id={"remediation-iframe"}
                      title={`Video: ${skill.title}`}
                      src={skill.content}
                      frameBorder="0"
                      allow="fullscreen"
                      lang="en"
                      className={classes.iframeStyle}
                      height={350}
                      width={560}
                    />
                  </Box>
                </Box>
              );
            })}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
